import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const {FiStar}=FiIcons;

const TestimonialsSection=()=> {
// WhatsApp message text encoded for URL 
const whatsappMessage=encodeURIComponent("Me interesa aplicarlo en mi negocio");
const whatsappLink=`https://wa.me/5214775954969?text=${whatsappMessage}`;

const testimonials=[ 
{name: "Hooters México",business: "",location: "Ciudad de México",image: "https://www.ticketfactura.com/wp-content/uploads/2025/08/hooters.jpg",quote: "Implementamos una nueva página web,un menú interactivo y quiniela para la NFL.",result: "Aumentó la participación de nuestros clientes"},
{name: "Cantina La No 20",business: "",location: "Ciudad de México",image: "https://www.ticketfactura.com/wp-content/uploads/2025/08/cantina-la-20.png",quote: "Automatizamos el proceso de facturación electrónica con un QR inteligente.",result: "Nuestros clientes generan su factura en segundos"},
{name: "50 Friends",business: "",location: "Ciudad de México",image: "https://www.ticketfactura.com/wp-content/uploads/2025/08/50-friends.jpg",quote: "Automatizamos el proceso de facturación electrónica con un QR inteligente.",result: "Nuestros clientes generan su factura en segundos"} 
];

return ( 
<section className="py-20 bg-gray-100"> 
<div className="container mx-auto px-4"> 
<motion.div className="max-w-4xl mx-auto text-center mb-12" initial={{opacity: 0,y: 50}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.8}} viewport={{once: true}} > 
<h2 className="text-4xl font-bold text-gray-800 mb-6"> Restaurantes que Ya Están <span className="text-orange-600">Usando Nuestras Soluciones</span> </h2> 
<p className="text-xl text-gray-600"> Estos son algunos de los restaurantes que han mejorado su servicio aplicando nuestras tecnologías </p> 
</motion.div> 
<div className="grid md:grid-cols-3 gap-8 mb-16"> 
{testimonials.map((testimonial,index)=> ( 
<motion.div key={index} className="bg-white rounded-xl shadow-xl overflow-hidden" initial={{opacity: 0,y: 50}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.6,delay: index * 0.2}} viewport={{once: true}} whileHover={{y: -10}} > 
<div className="p-6"> 
<div className="flex items-center mb-4"> 
<div className="w-16 h-16 rounded-full overflow-hidden mr-4"> 
<img src={testimonial.image} alt={testimonial.business} className="w-full h-full object-cover" /> 
</div> 
<div> 
<h3 className="font-bold text-lg text-gray-800">{testimonial.name}</h3> 
<p className="text-orange-600">{testimonial.business}</p> 
<p className="text-gray-500 text-sm">{testimonial.location}</p> 
</div> 
</div> 
<div className="flex mb-4"> 
{[...Array(5)].map((_,i)=> ( 
<SafeIcon key={i} icon={FiStar} className="text-yellow-500 fill-current" /> 
))} 
</div> 
<p className="text-gray-700 italic mb-4"> "{testimonial.quote}" </p> 
<div className="bg-orange-100 text-orange-700 font-semibold py-2 px-3 rounded-lg text-center"> {testimonial.result} </div> 
</div> 
</motion.div> 
))} 
</div> 
<motion.div className="max-w-3xl mx-auto text-center" initial={{opacity: 0,y: 50}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.8}} viewport={{once: true}} > 
<h3 className="text-3xl font-bold text-gray-800 mb-6"> ¿Quieres ser el próximo caso de éxito? </h3> 
<motion.a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 text-white font-bold text-xl px-8 py-4 rounded-full shadow-lg transform hover:scale-105 transition-all duration-300" whileHover={{scale: 1.05}} whileTap={{scale: 0.95}} > Aplíquenlo en mi negocio </motion.a> 
</motion.div> 
</div> 
</section> 
);};
export default TestimonialsSection;